import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchData: "",
  isSearchCall:false
};

const productSearchSlice = createSlice({
  name: "productsearch",
  initialState,
  reducers: {
    setProductSearchData: (state, action) => {
      state.searchData = action.payload;
    },
    setSearchDataEmty:(state)=>{
        state.searchData = ""
    },
    setSearchCall : (state,action)=>{
state.isSearchCall = action.payload
    }
  },
});

export const { setProductSearchData, setSearchDataEmty,setSearchCall } = productSearchSlice.actions;


export default productSearchSlice.reducer;